const intersect = (a, b) => [...new Set(a)].filter(x => new Set(b).has(x))

export default intersect



// WEBPACK FOOTER //
// ./src/utility/intersect.js